import FormActionButton, {
  type FormActionButtonProps,
} from './FormActionButton';

export type { FormActionButtonProps };
export default FormActionButton;
